import { useContext } from 'react';
import { Button } from '@mui/material';
import StepperContext from 'src/store/stepper-context';

/**
 * BackButton is a component that displays a button that takes the user to the previous step in a multi-step form.
 *
 * @param {Object} props - The props for the component.
 * @param {boolean} [props.disabled=false] - If true, the back button will be disabled.
 *
 * @returns {JSX.Element} - A JSX element representing the BackButton component.
 */
const BackButton = ({ disabled = false, text = 'Back' }) => {
  const { backStep } = useContext(StepperContext);

  return (
    <Button
      color="inherit"
      variant="text"
      disabled={disabled}
      onClick={backStep}
      disableRipple
      data-cy="back-button"
    >
      {text}
    </Button>
  );
};

export default BackButton;
